window.MTGGoldfish = window.MTGGoldfish || {};
window.MTGGoldfish.onDocumentReadyArray = window.MTGGoldfish.onDocumentReadyArray || [];
window.MTGGoldfish.onDocumentReadyArray.push(function() {
  textFill('.textfill', { maxFontPixels: 75 });
  textFill('.deck-visual-footer-copyright', { maxFontPixels: 10 });
  pieChart();
});

function pieChart() {

  // Set things up and draw the chart
  init();

  function init() {
    document.querySelectorAll("ins[data-type='donut-chart']").forEach(function(ins) {
      var totalValue = 0;
      var canvasWidth = parseFloat(ins.dataset.width);
      var canvasHeight = parseFloat(ins.dataset.height);
      var labelSize = parseFloat(ins.dataset.lsize);
      if (isNaN(labelSize)) labelSize = 20;

      var canvas = document.createElement('canvas');
      canvas.width = canvasWidth;
      canvas.height = canvasHeight;
      ins.appendChild(canvas);

      if (typeof canvas.getContext === 'undefined') return;

      var centreX = canvasWidth / 2;
      var centreY = canvasHeight / 2;
      var chartRadius = Math.min(canvasWidth, canvasHeight) / 2;
      var chartRadiusInner = 0.33 * chartRadius;

      var slices = [];
      ins.querySelectorAll("ins[data-type='donut-chart-entry']").forEach(function(entry) {
        var slice = {
          value: parseFloat(entry.dataset.value),
          label: entry.dataset.label,
          background: entry.dataset.background
        };
        slices.push(slice);
        totalValue += slice.value;
      });

      var currentPos = 0;
      slices.forEach(function(slice) {
        slice.startAngle = 2 * Math.PI * currentPos;
        slice.endAngle = 2 * Math.PI * (currentPos + (slice.value / totalValue));
        currentPos += slice.value / totalValue;
      });

      drawChart(canvas, canvasWidth, canvasHeight, centreX, centreY, chartRadius, chartRadiusInner, labelSize, slices);
    });
  }

  function drawChart(canvas, canvasWidth, canvasHeight, centreX, centreY, chartRadius, chartRadiusInner, labelSize, slices) {
    var context = canvas.getContext('2d');
    context.clearRect(0, 0, canvasWidth, canvasHeight);
    slices.forEach(function(slice) {
      drawSlice(context, slice, centreX, centreY, chartRadius, chartRadiusInner, labelSize);
    });
  }

  function drawSlice(context, slice, centreX, centreY, chartRadius, chartRadiusInner, labelSize) {
    var sliceBorderWidth = 1;
    var sliceBorderStyle = "#333430";
    var chartStartAngle = -.5 * Math.PI;

    var imageObj = new Image();
    imageObj.src = slice.background;
    imageObj.onload = function() {
      var manaSymbol = new Image();
      manaSymbol.src = slice.label;
      manaSymbol.onload = function() {
        var pattern = context.createPattern(imageObj, 'repeat');
        var startAngle = slice.startAngle + chartStartAngle;
        var endAngle = slice.endAngle + chartStartAngle;

        context.beginPath();
        context.arc(centreX, centreY, chartRadius, startAngle, endAngle, false);
        context.arc(centreX, centreY, chartRadiusInner, endAngle, startAngle, true);
        context.closePath();

        context.fillStyle = pattern;
        context.fill();
        context.shadowColor = "rgba( 0, 0, 0, 0 )";
        context.lineWidth = sliceBorderWidth;
        context.strokeStyle = sliceBorderStyle;

        var theta = endAngle - 0.5 * (endAngle - startAngle);
        var labelRadius = chartRadiusInner + 0.5 * (chartRadius - chartRadiusInner);
        var labelX = labelRadius * Math.cos(theta);
        var labelY = labelRadius * Math.sin(theta);

        context.drawImage(manaSymbol, centreX + labelX - 0.5 * labelSize, centreY + labelY - 0.5 * labelSize, labelSize, labelSize);
        context.stroke();
      };
    };
  }
}

window.MTGGoldfish.onDocumentReadyArray.push(function() {
  var legendHeight = 20;
  var canvasHeight = 150;
  var canvasWidth = 300;

  document.querySelectorAll("ins[data-type='bar-chart']").forEach(function(ins) {
    canvasWidth = parseFloat(ins.dataset.width);
    canvasHeight = parseFloat(ins.dataset.height);

    var canvas = document.createElement('canvas');
    canvas.width = canvasWidth;
    canvas.height = canvasHeight;
    ins.appendChild(canvas);

    if (typeof canvas.getContext === 'undefined') return;

    var context = canvas.getContext('2d');
    context.clearRect(0, 0, canvasWidth, canvasHeight);

    var bars = [];
    var maxValue = 0;
    var background = ins.dataset.background;

    ins.querySelectorAll("ins[data-type='bar-chart-entry']").forEach(function(entry) {
      var bar = {
        key: entry.dataset.key,
        value: parseFloat(entry.dataset.value)
      };
      bars.push(bar);
      if (bar.value > maxValue) maxValue = bar.value;
    });

    var barStartY = legendHeight;
    var barLabelHeight = 20;
    var barWidth = canvasWidth / bars.length;
    var maxBarHeight = canvasHeight - barStartY - barLabelHeight;

    var sliceBorderWidth = 1;
    var sliceBorderStyle = "#333430";

    var imageObj = new Image();
    imageObj.onerror = function() { ins.dataset.renderError = "Chart background failed to load"; };
    imageObj.src = background;
    imageObj.onload = function() {
      bars.forEach(function(bar, i) {
        var barHeight = maxBarHeight * bar.value / maxValue;
        context.rect(i * barWidth, barLabelHeight + maxBarHeight - barHeight, barWidth, barHeight);
        context.fillStyle = "#3abbf1";
        context.lineWidth = sliceBorderWidth;
        context.strokeStyle = sliceBorderStyle;
        context.fill();
        context.stroke();
        context.font = "bold 14px Open Sans";
        context.fillStyle = "#fff";
        context.textAlign = "center";
        context.fillText(bar.key, i * barWidth + barWidth / 2, canvasHeight - 5);
        if (bar.value > 0) {
          context.fillText(bar.value, i * barWidth + barWidth / 2, barLabelHeight + maxBarHeight - barHeight - 5);
        }
      });
      ins.dataset.rendered = "true";
    };
  });
});
